/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/prototype/rib 层；
 * 2. 负责定义筋特征原型对象；
 * 3. 该原型对象是设计树、编辑会话与结果对象共享的筋领域入口。
 */

import type { FeatureReferenceBinding } from '../../binding/FeatureReferenceBinding';
import { RibFeatureDefinitionModel } from '../../definition/rib/RibFeatureDefinition';
import { FeaturePrototype } from '../FeaturePrototype';

/**
 * 筋特征原型。
 */
export class RibFeaturePrototype extends FeaturePrototype<RibFeatureDefinitionModel> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        featureId: string;
        definition: RibFeatureDefinitionModel;
        bindings: FeatureReferenceBinding[];
        sourceSketchId?: string | null;
    }) {
        super(input);
    }
}
